import { IErrorResult } from '@/types/dto';
import { AxiosError } from 'axios';
import { ElMessage, ElNotification } from 'element-plus';
import getErrorMessage from './getErrorMessage';

export default function funcError(error: AxiosError<IErrorResult> | string, notify = false): void {
  if (!error) return;

  const message = getErrorMessage(error);

  if (notify) {
    ElNotification({
      title: '错误',
      message,
      type: 'error',
      position: 'top-right',
      duration: 5000,
    });
  } else {
    ElMessage({
      type: 'error',
      message,
      showClose: true,
      duration: 5000,
    });
  }
}
